export default function Dialogue ({ children }) {
  const content = children.map((child, i) => {
    if (child.type === 'Italic') {
      return <Italic key={i}>{child.text}</Italic>
    } else {
      return child.text
    }
  })

  return (
    <div className='my-5'>
      <div className='flex'>
        <div className='flex-1' />
        <div className='flex-5'>
          {content}
        </div>
        <div className='flex-1' />
      </div>
    </div>
  )
}

function Italic ({ children }) {
  return (<span className='italic'> {children} </span>)
}
